export default __webpack_public_path__ + "static/jacky-6430d02f9f8bc6a6861c4a14a3b3011f.jpg";